<div *ngIf="alwaysShown || ((!calendarProvider || (showLocal || !calendarProvider.isLocal)) &&
        ((meetingCalendarIntegrationDismissed$ | async) === false || (oauthService.isAuthenticated$ | async) === true))"
     class="alert alert-info pt-2 d-flex gap-3 align-items-end flex-wrap">
    <div class="flex-grow-1">
        <strong class="d-flex alert-heading mb-3 align-items-center">
            <a *ngIf="!linkDisabled && calendarProvider && !calendarProvider.isLocal && oauthService.user; else noConfigLink"
               class="text-reset"
               adaptTooltip="Click here to logout or switch accounts for this provider"
               [routerLink]="personalConfigRoute?.path"
               [queryParams]="{section: ConfigArea[ConfigArea.CalendarIntegration]}">Calendar integration</a>
            <ng-template #noConfigLink>Calendar integration</ng-template>
            <i *ngIf="!calendarProvider || !calendarProvider.isLocal"
               class="fal fa-info-circle ms-2"
               adaptTooltip="Meetings will be sent to your nominated calendar provider."></i>
            <button *ngIf="isDismissible && (!calendarProvider || !calendarProvider.isLocal) && (oauthService.isAuthenticated$ | async) === false"
                    adaptButton="closeBorderless"
                    adaptTooltip="Dismiss this prompt and don't show it again for all teams"
                    class="ms-auto"
                    (click)="dismissPrompt()"></button>
        </strong>

        <p *ngIf="showTextPrompt && !oauthService.user">{{oauthService.getPromptText(true)}}</p>
        <div [ngClass]="{'d-flex justify-content-center': !oauthService.user}">
            <adapt-calendar-provider-select [disabled]="disabled"
                                            [showDisableIntegration]="false"></adapt-calendar-provider-select>
        </div>
    </div>

    <ng-container *ngIf="contentTemplate"
                  [ngTemplateOutlet]="contentTemplate"
                  [ngTemplateOutletContext]="{$implicit: calendarProvider, user: oauthService.user}"></ng-container>
</div>
